export const IGNORED_ACCOUNTS: string[] = [
  'fc1a282d-ccae-4807-a762-49e5b73304a4',
  'a0fdf76d-623e-4997-98af-40a319b7de42',
  '17a12577-64c0-420b-8979-4464ea365f5c',
  '83ac1172-5a14-48bb-9322-7f5834f9c27c',
  '8d8da3f8-5ee0-4ee6-9b94-f59e0a799f4e',
  '3336ed55-8fac-4cad-b172-3e3c4d2eb8a2',
  '601be90f-22f7-4742-bd74-c087c42b9f03',
  'ed5b0900-09c1-4b3c-bcf1-f5131b5fc8f4',
  '07f4cc48-128c-4317-9530-b150c6e364a3',
  '5d6dc016-7415-4e2f-b932-2ef97642162d',
];

export function isIgnoredAccount(accountId: string): boolean {
  return IGNORED_ACCOUNTS.includes(accountId)
}
